import router from '@/router'
import Cookies from 'js-cookie'

export const getRefLink = async () => {
  if (window.location.href.includes('/a/')) {
    const ref = window.location.hash.split('/a/')[1].split('/')[0]
    if (ref) {
      const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)

      Cookies.set('a', ref, {
        expires,
        path: '/',
      })

      await router.push('/auth/registration')
    }
  }
}
